import React from 'react';
import { LoaderPukaUp } from 'app/components/LoaderPukaUp';

function ErrorFallback({ error, resetErrorBoundary }) {
  return <LoaderPukaUp />;
}

export default ErrorFallback;
